var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blob-image-viewer-root"},[_c('canvas',{ref:"canvas",staticClass:"blob-image-viewer-canvas",attrs:{"width":"400px","height":"300px"},on:{"dragover":_vm.onDragOver,"drop":_vm.onDrop}})])}
var staticRenderFns = []

export { render, staticRenderFns }